<template>
  <div>
    <h1 class="title">Bestellung {{ id }}</h1>
    <b-message v-if="apiError" type="is-danger" :closable="false">
      {{ apiError }}
    </b-message>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <p class="title">PDF</p>
          <button
            class="button is-primary"
            type="submit"
            @click="downloadRequest(id, 'pdf')"
            :disabled="isLoading"
          >
            <b-icon icon="download"></b-icon><span>Download</span>
          </button>
          &nbsp;
          <button
            class="button is-light"
            type="submit"
            @click="openRequest(id, 'pdf')"
            :disabled="isLoading"
          >
            <b-icon icon="open-in-new"></b-icon><span>Open</span>
          </button>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <p class="title">HTML</p>
          <button
            class="button is-primary"
            type="submit"
            @click="downloadRequest(id, 'html')"
            :disabled="isLoading"
          >
            <b-icon icon="download"></b-icon><span>Download</span>
          </button>
          &nbsp;
          <button
            class="button is-light"
            type="submit"
            @click="openRequest(id, 'html')"
            :disabled="isLoading"
          >
            <b-icon icon="open-in-new"></b-icon><span>Open</span>
          </button>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <p class="title">JSON</p>
          <button
            class="button is-primary"
            type="submit"
            @click="downloadRequest(id, 'json')"
            :disabled="isLoading"
          >
            <b-icon icon="download"></b-icon><span>Download</span>
          </button>
          &nbsp;
          <button
            class="button is-light"
            type="submit"
            @click="openRequest(id, 'json')"
            :disabled="isLoading"
          >
            <b-icon icon="open-in-new"></b-icon><span>Open</span>
          </button>
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <p class="title">BON</p>
          <button
            class="button is-primary"
            type="submit"
            @click="downloadRequest(id, 'bon')"
            :disabled="isLoading"
          >
            <b-icon icon="download"></b-icon><span>Download</span>
          </button>
          &nbsp;
          <button
            class="button is-light"
            type="submit"
            @click="openRequest(id, 'bon')"
            :disabled="isLoading"
          >
            <b-icon icon="open-in-new"></b-icon><span>Open</span>
          </button>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import FileSaver from "file-saver";
import Api from "../api";
import auth from "../auth";

export default {
  data() {
    return {
      id: this.$route.query.id,
      sesid: auth.getSesId(),
      apiError: "",
      isLoading: false
    };
  },
  methods: {
    downloadRequest: async function(reqid, format) {
      let vm = this;

      vm.isLoading = true;
      vm.apiError = "";

      let url = "get/request/" + encodeURIComponent(reqid) + "/" + format;
      let filename = "wls-" + reqid + "." + format;

      try {
        const res = await Api.getBlob("post", url);
        let type = res.headers["content-type"];
        let blob = new Blob([res.data], {
          type: type
        });
        FileSaver.saveAs(blob, filename);
      } catch (error) {
        if (error.response.status == 401) {
          vm.$router.replace({
            path: "/login",
            query: {
              reason: "sessionExpired",
              redirect: vm.$route.fullPath
            }
          });
        }
        vm.apiError = Api.getFirstError(error);
      }

      vm.isLoading = false;
    },
    openRequest: function(reqid, format) {
      let url =
        "api/get/request/" +
        reqid +
        "/" +
        format +
        "?sesid=" +
        encodeURIComponent(this.sesid);
      window.open(url, "_blank");
    }
  },
  mounted: function() {
    // this.downloadRequest(this.id, "pdf");
  }
};
</script>
